import { Box, Stack, Typography } from "@mui/material";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const FraudCorrectionApplied = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const stage4Text = getDeepViewValuesEntry(
    deepViewData,
    columnKey,
  )?.stage4_prefilled;

  if (!stage4Text) return null;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #D32F2F80",
          borderRadius: "8px",
          backgroundColor: "#D32F2F0A",
          p: 1,
          my: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <ReportProblemIcon
            sx={{
              color: "#C62828",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#C62828",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Fraud Correction Applied
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#C62828",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(stage4Text)}
        </Typography>
      </Box>
    </>
  );
};

export default FraudCorrectionApplied;
